/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UboDeclarationResponseCompany } from './';
import {
    UboDeclarationResponseCompanyFromJSON,
    UboDeclarationResponseCompanyFromJSONTyped,
    UboDeclarationResponseCompanyToJSON,
} from './';
import type { UboDeclarationResponseLegalRepresentative } from './';
import {
    UboDeclarationResponseLegalRepresentativeFromJSON,
    UboDeclarationResponseLegalRepresentativeFromJSONTyped,
    UboDeclarationResponseLegalRepresentativeToJSON,
} from './';
import type { UboDeclarationResponseUniqueBeneficialOwnersInner } from './';
import {
    UboDeclarationResponseUniqueBeneficialOwnersInnerFromJSON,
    UboDeclarationResponseUniqueBeneficialOwnersInnerFromJSONTyped,
    UboDeclarationResponseUniqueBeneficialOwnersInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface UboDeclarationResponse
 */
export interface UboDeclarationResponse {
    /**
     * 
     * @type {Array<UboDeclarationResponseUniqueBeneficialOwnersInner>}
     * @memberof UboDeclarationResponse
     */
    uniqueBeneficialOwners: Array<UboDeclarationResponseUniqueBeneficialOwnersInner>;
    /**
     * 
     * @type {UboDeclarationResponseCompany}
     * @memberof UboDeclarationResponse
     */
    company: UboDeclarationResponseCompany;
    /**
     * 
     * @type {UboDeclarationResponseLegalRepresentative}
     * @memberof UboDeclarationResponse
     */
    legalRepresentative: UboDeclarationResponseLegalRepresentative;
}

/**
 * Check if a given object implements the UboDeclarationResponse interface.
 */
export function instanceOfUboDeclarationResponse(value: object): value is UboDeclarationResponse {
    if (!('uniqueBeneficialOwners' in value) || value['uniqueBeneficialOwners'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('legalRepresentative' in value) || value['legalRepresentative'] === undefined) return false;
    return true;
}

export function UboDeclarationResponseFromJSON(json: any): UboDeclarationResponse {
    return UboDeclarationResponseFromJSONTyped(json, false);
}

export function UboDeclarationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uniqueBeneficialOwners': ((json['uniqueBeneficialOwners'] as Array<any>).map(UboDeclarationResponseUniqueBeneficialOwnersInnerFromJSON)),
        'company': UboDeclarationResponseCompanyFromJSON(json['company']),
        'legalRepresentative': UboDeclarationResponseLegalRepresentativeFromJSON(json['legalRepresentative']),
    };
}

export function UboDeclarationResponseToJSON(value?: UboDeclarationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'uniqueBeneficialOwners': ((value['uniqueBeneficialOwners'] as Array<any>).map((v) => UboDeclarationResponseUniqueBeneficialOwnersInnerToJSON(v))),
        'company': UboDeclarationResponseCompanyToJSON(value['company']),
        'legalRepresentative': UboDeclarationResponseLegalRepresentativeToJSON(value['legalRepresentative']),
    };
}

